import { render, staticRenderFns } from "./Salesman-main.vue?vue&type=template&id=824c0982"
import script from "./Salesman-main.vue?vue&type=script&lang=js"
export * from "./Salesman-main.vue?vue&type=script&lang=js"
import style0 from "./Salesman-main.vue?vue&type=style&index=0&id=824c0982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports